import ActionTypes from './ActionTypes';
export default function createLocationMiddleware(_ref) {
  var makeLocationDescriptor = _ref.makeLocationDescriptor,
      makeLocation = _ref.makeLocation;
  return function locationMiddleware() {
    return function (next) {
      return function (action) {
        var type = action.type,
            payload = action.payload;

        switch (type) {
          case ActionTypes.NAVIGATE:
          case ActionTypes.CREATE_HREF:
            return next({
              type: type,
              payload: makeLocationDescriptor(payload)
            });

          case ActionTypes.CREATE_LOCATION:
            return makeLocation(next({
              type: type,
              payload: makeLocationDescriptor(payload)
            }));

          case ActionTypes.UPDATE_LOCATION:
            return next({
              type: type,
              payload: makeLocation(payload)
            });

          default:
            return next(action);
        }
      };
    };
  };
}